import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { authService } from "@data/services/authService"
import { stageFunnelService } from "../../../../stage/services/stageFunnelService"

const initialState = {
    // Funnel state persisted server-side under this id (pre-auth lead capture).
    funnelStateId: null,
    userId: null,
    // Pré-rempli renvoyé par /init (HubSpot hydration) — firstname / email /
    // student_class / student_class_rentree. L'écran classe pioche dedans.
    initUser: null,
    // Slug du template résolu par /init ou /start depuis le lead_intent —
    // clé wire `template_slug` (contrat StageFunnelController). Il scope le
    // fetch matières et le catalogue dès le premier écran.
    templateSlug: null,
    // Le serveur a reconnu un élève abonné (/start, /init, reprise) : sa classe
    // est celle du profil, qu'il renvoie, et l'écran classe l'envoie au choix
    // des semaines.
    profileKnown: false,
    studentClass: null,
    // Snapshot du dernier GET /stage-funnel/{id} (deep link reprise).
    serverState: null,
}

export function stageFunnel(state = initialState, action) {
    switch (action.type) {
        case stageFunnelService.startStageFunnel.name + apiConstants._SUCCESS: {
            const payload = action.data || {}
            return {
                ...state,
                funnelStateId:
                    payload.funnel_state_id ??
                    payload.funnelStateId ??
                    state.funnelStateId,
                userId: payload.user_id ?? payload.userId ?? state.userId,
                templateSlug:
                    payload.template_slug ??
                    payload.templateSlug ??
                    state.templateSlug,
                profileKnown: !!payload.profile_known,
                studentClass: payload.student_class ?? null,
            }
        }

        case stageFunnelService.initStageFromHubSpot.name +
            apiConstants._SUCCESS: {
            const payload = action.data || {}
            return {
                ...state,
                funnelStateId:
                    payload.funnel_state_id ??
                    payload.funnelStateId ??
                    state.funnelStateId,
                initUser: payload.user ?? state.initUser,
                templateSlug:
                    payload.template_slug ??
                    payload.templateSlug ??
                    state.templateSlug,
                profileKnown: !!payload.profile_known,
                studentClass: payload.user?.student_class ?? null,
            }
        }

        // La reprise fait autorité sur l'identité de l'onglet, dès son départ :
        // le store gardait sinon le parcours de la famille PRÉCÉDENTE, que
        // l'écran classe recopiait pour une famille arrivée sans parcours.
        case stageFunnelService.resumeStage.name + apiConstants._REQUEST:
            return {
                ...state,
                funnelStateId: null,
                userId: null,
                initUser: null,
                templateSlug: null,
                profileKnown: false,
                studentClass: null,
            }

        case stageFunnelService.resumeStage.name + apiConstants._SUCCESS: {
            const payload = action.data || {}
            return {
                ...state,
                funnelStateId: payload.funnel_state_id ?? null,
                userId: payload.user?.id ?? null,
                initUser: null,
                templateSlug:
                    payload.checkout_params?.template_slug ??
                    payload.template_slug ??
                    null,
                profileKnown: !!payload.profile_known,
                studentClass: payload.user?.student_class ?? null,
            }
        }

        case stageFunnelService.getStageFunnelState.name +
            apiConstants._SUCCESS: {
            const payload = action.data || {}
            return {
                ...state,
                serverState: payload,
            }
        }

        // Reset on logout — required for any user-scoped data.
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
            return initialState

        default:
            return state
    }
}

export default stageFunnel
